export default __webpack_public_path__ + "static/leader_1-1c02d1fadd660f35624c9e3734966705.png";